module.exports = __webpack_public_path__ + "static/media/investor.154434ee.png";